// extracted by mini-css-extract-plugin
module.exports = {"slideMask":"slideMaskText-module--slideMask--2npM2","slideMaskChild":"slideMaskText-module--slideMaskChild--1Dlhf"};